import { render, staticRenderFns } from "./survey-header.vue?vue&type=template&id=05a76833&"
import script from "./survey-header.vue?vue&type=script&lang=js&"
export * from "./survey-header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports